import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { open: { type: Boolean, default: false } }
  static targets = ["button"]
  static classes = ["open"]

  openValueChanged() {
    this.element.classList.toggle(this.openClass, this.openValue)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.openValue)
    }
  }

  toggle() {
    this.openValue = !this.openValue
    if (this.openValue) this.#collapseSiblings()
  }

  close() {
    this.openValue = false
  }

  #collapseSiblings() {
    this.#siblingControllers.forEach(siblingController => {
      if (siblingController) siblingController.close()
    })
  }

  get #siblingControllers() {
    return this.#siblings.map(sibling => {
      return this.application.getControllerForElementAndIdentifier(
        sibling,
        this.identifier
      )
    })
  }

  get #siblings() {
    return [...this.element.parentElement.children].filter(
      element => element !== this.element
    )
  }
}
